const Error = (props) =>{
    let path = props.path
    let arr = path.split('/')
    let errMessage ;
    let errCode ;
    switch (arr[1]) {
        case '401':
            errMessage = 'Please Login as your token has expired'
            errCode = 401
            break
        case '500':
            errMessage = 'Internal Server Error'
            errCode = 500
            break
        case '403':
            errMessage = 'I see you are a man of culture'
            errCode = 403
            break
        default:
            errMessage = 'Page not found'
            errCode = 404
            break
    }
    return(
        <div className='columns'>
            <div className='column is-6 is-offset-3'>
                <p className='has-text-centered is-size-1 has-text-weight-bold'>{errCode}</p>
                <p className='has-text-centered is-size-1 has-text-weight-bold'>{errMessage}</p>
            </div>
        </div>
    )
}

export default Error